import React from 'react';

const ChevronIcon = ({ open }) => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        style={{
            flexShrink: 0,
            color: '#cfd6e4',
            transition: 'transform 140ms ease',
            transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
        }}
    >
        <path d="M4.5 2.5L8 6l-3.5 3.5" />
    </svg>
);

const SearchIcon = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 20 20"
        fill="currentColor"
        style={{ color: '#8d97aa', pointerEvents: 'none' }}
    >
        <path
            fillRule="evenodd"
            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
        />
    </svg>
);

function GrupoDocumentos({ tipo, docs, allDocs, isOpen, onToggleGroup, onToggle, onVigencia, searchTerm }) {
    const totalGrupo = allDocs.filter((d) => (d.tipo || 'Logística') === tipo).length;
    const selGrupo   = allDocs.filter((d) => (d.tipo || 'Logística') === tipo && d.selected).length;
    const pct = totalGrupo > 0 ? (selGrupo / totalGrupo) * 100 : 0;
    const completo = selGrupo === totalGrupo && totalGrupo > 0;

    return (
        <div style={{ borderBottom: '1px solid #e4e8f0' }} className="last:border-b-0">
            {/* Cabecera colapsable */}
            <button
                type="button"
                onClick={() => onToggleGroup(tipo)}
                className="flex items-center gap-3 w-full text-left"
                style={{ padding: '13px 26px', border: 'none', background: 'transparent', cursor: 'pointer' }}
            >
                <ChevronIcon open={isOpen} />

                <span
                    style={{
                        fontSize: 12,
                        fontWeight: 600,
                        letterSpacing: '0.1em',
                        textTransform: 'uppercase',
                        color: '#5c6880',
                        flexShrink: 0,
                    }}
                >
                    {tipo}
                </span>

                {/* Barra de progreso */}
                <div
                    className="flex-1"
                    style={{
                        height: 4,
                        minWidth: 40,
                        background: '#e4e8f0',
                        borderRadius: 20,
                        overflow: 'hidden',
                    }}
                >
                    <div
                        style={{
                            height: '100%',
                            width: `${pct}%`,
                            background: '#17a06f',
                            borderRadius: 20,
                            transition: 'width 220ms ease',
                        }}
                    />
                </div>

                {/* Conteo */}
                <span
                    style={{
                        fontFamily: 'ui-monospace, monospace',
                        fontSize: 12,
                        color: completo ? '#0f7554' : '#8d97aa',
                        flexShrink: 0,
                        minWidth: 44,
                        textAlign: 'right',
                    }}
                >
                    {selGrupo}/{totalGrupo}
                </span>
            </button>

            {/* Filas de documentos */}
            {isOpen && (
                <div style={{ paddingBottom: 12 }}>
                    {docs.length > 0 ? (
                        docs.map((doc) => (
                            <div
                                key={doc._id}
                                className="flex items-center gap-3"
                                style={{
                                    padding: '7px 12px 7px 26px',
                                    borderRadius: 6,
                                    margin: '0 14px',
                                    background: doc.selected ? '#ffffff' : 'transparent',
                                    transition: 'background 100ms ease',
                                    cursor: 'default',
                                }}
                                onMouseEnter={(e) => !doc.selected && (e.currentTarget.style.background = '#fafbfc')}
                                onMouseLeave={(e) => !doc.selected && (e.currentTarget.style.background = 'transparent')}
                            >
                                <input
                                    type="checkbox"
                                    checked={doc.selected}
                                    onChange={() => onToggle(doc._id)}
                                    style={{ width: 16, height: 16, flexShrink: 0, accentColor: '#17347f', cursor: 'pointer' }}
                                />

                                <span
                                    className="flex-1 min-w-0"
                                    style={{
                                        fontSize: 13,
                                        color: doc.selected ? '#131a2e' : '#8d97aa',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {doc.documentoGeneral}
                                </span>

                                {doc.exigeFecha === 'SI' && doc.selected && (
                                    <div className="flex items-center gap-2 flex-shrink-0">
                                        {doc.vigenciaPersonalizada != null ? (
                                            <span
                                                style={{
                                                    fontSize: 11,
                                                    fontFamily: 'ui-monospace, monospace',
                                                    fontWeight: 500,
                                                    background: '#fef8ea',
                                                    color: '#b8790a',
                                                    border: '1px solid #fdeec6',
                                                    borderRadius: 20,
                                                    padding: '1px 8px',
                                                }}
                                            >
                                                {doc.vigenciaPersonalizada}d
                                            </span>
                                        ) : (
                                            <span style={{ fontSize: 12, color: '#8d97aa' }}>
                                                {doc.vigencia ?? '—'}d global
                                            </span>
                                        )}
                                        <input
                                            type="number"
                                            min="0"
                                            value={doc.vigenciaPersonalizada ?? ''}
                                            onChange={(e) => onVigencia(doc._id, e.target.value)}
                                            placeholder="días"
                                            style={{
                                                width: 68,
                                                height: 30,
                                                textAlign: 'right',
                                                padding: '0 8px',
                                                border: '1px solid #2551c4',
                                                borderRadius: 6,
                                                fontFamily: 'ui-monospace, monospace',
                                                fontSize: 13,
                                                outline: 'none',
                                            }}
                                            onFocus={(e) => (e.target.style.boxShadow = '0 0 0 3px #eef3fd')}
                                            onBlur={(e) => (e.target.style.boxShadow = 'none')}
                                        />
                                    </div>
                                )}

                                {doc.exigeFecha === 'SI' && !doc.selected && (
                                    <span style={{ fontSize: 12, color: '#cfd6e4', flexShrink: 0 }}>
                                        {doc.vigencia ?? '—'}d
                                    </span>
                                )}
                            </div>
                        ))
                    ) : (
                        <p
                            style={{ fontSize: 13, color: '#8d97aa', margin: 0, padding: '0 26px 8px' }}
                        >
                            {searchTerm
                                ? 'Sin coincidencias.'
                                : `No hay documentos de ${tipo.toLowerCase()} configurados.`}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
}

const ListaConfigCarpeta = ({
    docsLogistica,
    docsObra,
    docsAnexo,
    allDocs,
    openGroups,
    searchTerm,
    onSearchChange,
    onToggle,
    onVigencia,
    onToggleGroup,
}) => {
    return (
        <>
            {/* Barra de herramientas */}
            <div
                className="flex items-center gap-3 flex-wrap"
                style={{ padding: '13px 26px', borderBottom: '1px solid #e4e8f0' }}
            >
                <div className="relative flex-1" style={{ minWidth: 220 }}>
                    <span
                        className="absolute top-1/2 -translate-y-1/2"
                        style={{ left: 11 }}
                    >
                        <SearchIcon />
                    </span>
                    <input
                        type="text"
                        placeholder="Buscar documentos..."
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        style={{
                            width: '100%',
                            height: 36,
                            padding: '0 34px',
                            border: '1px solid #cfd6e4',
                            borderRadius: 6,
                            fontSize: 13,
                            color: '#131a2e',
                            outline: 'none',
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = '#2551c4';
                            e.target.style.boxShadow = '0 0 0 3px #eef3fd';
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = '#cfd6e4';
                            e.target.style.boxShadow = 'none';
                        }}
                    />
                    {searchTerm && (
                        <button
                            type="button"
                            onClick={() => onSearchChange('')}
                            className="absolute top-1/2 -translate-y-1/2 flex items-center justify-center rounded-full hover:bg-gray-100"
                            style={{ right: 6, width: 20, height: 20, border: 'none', background: 'transparent', cursor: 'pointer', color: '#8d97aa', fontSize: 15 }}
                        >
                            ×
                        </button>
                    )}
                </div>
            </div>

            {/* Grupos */}
            <div>
                <GrupoDocumentos
                    tipo="Logística"
                    docs={docsLogistica}
                    allDocs={allDocs}
                    isOpen={openGroups['Logística']}
                    onToggleGroup={onToggleGroup}
                    onToggle={onToggle}
                    onVigencia={onVigencia}
                    searchTerm={searchTerm}
                />
                <GrupoDocumentos
                    tipo="Obra"
                    docs={docsObra}
                    allDocs={allDocs}
                    isOpen={openGroups['Obra']}
                    onToggleGroup={onToggleGroup}
                    onToggle={onToggle}
                    onVigencia={onVigencia}
                    searchTerm={searchTerm}
                />
                <GrupoDocumentos
                    tipo="Anexo"
                    docs={docsAnexo}
                    allDocs={allDocs}
                    isOpen={openGroups['Anexo']}
                    onToggleGroup={onToggleGroup}
                    onToggle={onToggle}
                    onVigencia={onVigencia}
                    searchTerm={searchTerm}
                />
            </div>
        </>
    );
};

export default ListaConfigCarpeta;
